import React from "react";
import { Box } from "@mui/material";
import TransferContainers from "./TransferContainers";
import LocateContainers from "./LocateContainers";
import DiscardContainers from "./DiscardContainers";
import ReceiveContainer from "./ReceiveContainer";
import ManageContainersData from "./ManageContainerData";
import BulkContainers from "./BulkContainers";
import { GlobalTabCollection, StyledTab } from "../../styles.js";


const ManageContainers = ({ ...props }) => {
  const [tabValue, setTabValue] = React.useState(0);
  const [containersTransfer, setContainersTransfer] = React.useState([]);
  const [containersDiscard, setContainersDiscard] = React.useState([]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderSearchTab = () => {
    switch (tabValue) {
      case 0: {
        return <LocateContainers setTabValue={setTabValue} setContainersTransfer={setContainersTransfer} setContainersDiscard={setContainersDiscard} ></LocateContainers>;
      }
      case 1: {
        return <DiscardContainers containersDiscard={containersDiscard} setContainersDiscard={setContainersDiscard} ></DiscardContainers>;
      }
      case 2: {
        return <ReceiveContainer></ReceiveContainer>;
      }
      case 3: {
        return <TransferContainers containersTransfer={containersTransfer} setContainersTransfer={setContainersTransfer} ></TransferContainers>;
      }
      case 4: {
        return <ManageContainersData></ManageContainersData>;
      }
      case 5: {
        return <BulkContainers></BulkContainers>;
      }
      default: {
        alert(tabValue);
      }
    }
  };

  return (
    <>
      <div>
        <Box sx={{ bgcolor: "#fff" }}>
          <GlobalTabCollection value={tabValue} onChange={handleChange} aria-label='ant example'>
            <StyledTab label='Locate Containers'/>
            <StyledTab label='Discard Containers'/>
            <StyledTab label='Receive Container'/>
            <StyledTab label='Transfer Containers'/>
            <StyledTab label='Manage Container Data'/>
            <StyledTab label='Bulk Containers'/>
          </GlobalTabCollection>
          <Box sx={{ p: 3 }} />
        </Box>
        {renderSearchTab()}
      </div>
    </>
  );
};

export default ManageContainers;